import { ReactComponent as CSKHIcon } from "assets/mobile/icons/bottom-navigate/cskh.svg";
import { ReactComponent as HomeIcon } from "assets/mobile/icons/bottom-navigate/home.svg";
import { ReactComponent as PromotionIcon } from "assets/mobile/icons/bottom-navigate/promotion.svg";
import { ReactComponent as UserIcon } from "assets/mobile/icons/bottom-navigate/user.svg";
import { ReactComponent as LockWithdrawIcon } from "assets/mobile/icons/lock-screen.svg";
import { ReactComponent as EventIcon } from "assets/mobile/icons/menu/event.svg";
import { ReactComponent as FavouritIcon } from "assets/mobile/icons/menu/favourite.svg";
import { ReactComponent as HistoryIcon } from "assets/mobile/icons/menu/history.svg";
import { ReactComponent as ListIcon } from "assets/mobile/icons/menu/list.svg";
import { ReactComponent as MailIcon } from "assets/mobile/icons/menu/mail.svg";
import { ReactComponent as NotificationIcon } from "assets/mobile/icons/menu/notification.svg";
import { ReactComponent as RefundIcon } from "assets/mobile/icons/menu/refund.svg";
import { ReactComponent as SecurityIcon } from "assets/mobile/icons/menu/security.svg";

export const MobileIcons = {
  Mail: MailIcon,
  History: HistoryIcon,
  List: ListIcon,
  Event: EventIcon,
  Favourite: FavouritIcon,
  Security: SecurityIcon,
  Notification: NotificationIcon,
  Refund: RefundIcon,
  LockWithdrawIcon: LockWithdrawIcon,

  //bottom navigate
  Home: HomeIcon,
  Promotion: PromotionIcon,
  CSKH: CSKHIcon,
  User: UserIcon,
};
